import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Breakpoints from "../../constants/breakpoints";

const Section = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(19.4rem, 90rem) minmax(0, 1fr);
  padding-top: ${props => props.paddingTop || '160px'};
  padding-bottom:  ${props => props.paddingBottom || '160px'};
  background-color: ${props => props.bgColor || '#FFFFFF'};
  overflow: hidden;
`;

const Content = styled.div`
  grid-column: 2 / 3;
  display: flex;
  flex-direction: column;
  padding-left: 4rem;
  padding-right: 4rem;

  @media only screen and (max-width: ${Breakpoints.Width.laptop_medium}) {
    padding-left: 3rem;
  }

  @media only screen and (max-width: ${Breakpoints.Width.tablet_small}) {
    padding-left: 2rem;
  }
  
  .section-content__header {
    display: flex;
    flex-direction: row;
    margin-bottom: 3.5rem;
    
    @media only screen and (max-width: ${Breakpoints.Width.tablet}) {
      flex-direction: column;
    }
  }
  
  .section-content__title {
    display: flex;
    flex-direction: column;
    width: ${props => props.noDescription? 'auto': '33.3333%'};
    max-width: ${props => props.noDescription? '100%' : '30rem'};
    min-width: 13rem;
    
    @media only screen and (max-width: ${Breakpoints.Width.tablet}) {
      width: 100%;
      max-width: 100%;
    }
    
  }
  
  .section-content__description {
    display: flex;
    flex-direction: column;
    margin-left: 160px;
    margin-top: 68px;
    max-width: 37.5rem;

    @media only screen and (max-width: ${Breakpoints.Width.laptop_large}) {
      margin-left: 120px;
    }

    @media only screen and (max-width: ${Breakpoints.Width.laptop_medium}) {
      margin-left: 100px;
      margin-top: 60px;
      max-width: 30rem;
    }

    @media only screen and (max-width: ${Breakpoints.Width.laptop_small}) {
      margin-left: 80px;
    }

    @media only screen and (max-width: ${Breakpoints.Width.tablet}) {
      margin-left: 0;
      margin-top:0;
      width: 100%;
      max-width: 100%;
    }

    &--list {
      margin-top: 0;
    }
  }

`;

const ProjectSection = props => {
  return(
    <Section className="section-container" paddingTop={props.paddingTop} paddingBottom={props.paddingBottom} bgColor={props.bgColor} name={props.name}>
      <Content className="section-content" noDescription={props.noDescription}>
        {props.children}  
      </Content>
    </Section>
  );

}

ProjectSection.propTypes = {
  noDescription: PropTypes.bool,
}

ProjectSection.defaultProps = {
  noDescription: false,
}

export default ProjectSection;